module.exports = __webpack_public_path__ + "img/logo_v3-negative.44b6a07d.png";